export const tableDataSchemas = [
  {
    prop: 'name',
    label: '租户名称',
    minWidth: 120
  },
  {
    prop: 'createTime',
    label: '创建时间',
    minWidth: 120
  },
  {
    prop: 'action',
    label: '操作',
    minWidth: 120,
    btnArr: ['info']
  }
]

export const infoTableDataSchemas = [
  {
    prop: 'appName',
    label: '应用名称',
    minWidth: 120
  },
  {
    prop: 'tenantName',
    label: '租户名称',
    minWidth: 120
  },
  {
    prop: 'clinicName',
    label: '门诊名称',
    minWidth: 120
  },

  {
    prop: 'beginTime',
    label: '授权开始时间',
    minWidth: 120
  },
  {
    prop: 'endTime',
    label: '授权结束时间',
    minWidth: 120
  },
  {
    prop: 'applyStatus',
    label: '应用状态',
    minWidth: 80
  },
  {
    prop: 'approvalStatus',
    label: '审批状态',
    minWidth: 80
  },
  {
    prop: 'action',
    label: '操作',
    minWidth: 120,
    btnArr: ['update', 'approval', 'delete', 'async']
  }
]

// 基础设置 form
export const formSchemas = [
  {
    field: 'name',
    defaultValue: '',
    component: 'Cascader',
    label: '租户',
    placeholder: '请选择租户',
    rules: [
      {
        required: true,
        message: '租户不能为空'
      }
    ]
  },

  {
    field: 'authTime',
    defaultValue: '',
    component: 'DateInterval',
    label: '授权时间',
    placeholder: '请选择授权时间',
    radioArr: [],
    rules: [
      {
        required: true,
        message: '授权时间不能为空'
      }
    ]
  },
  {
    field: 'moduleConfig',
    defaultValue: '',
    component: 'Radio',
    label: '应用配置',
    placeholder: '请选择应用配置',
    radioArr: [],
    rules: [
      {
        required: true,
        message: '请选择一个应用不能为空'
      }
    ]
  }
]

// 修改设置 form
export const updateFormSchemas = [
  {
    field: 'name',
    defaultValue: '',
    component: 'Input',
    disabled: true,
    label: '租户名'
  },
  {
    field: 'clinicName',
    defaultValue: '',
    component: 'Input',
    disabled: true,
    label: '诊所名'
  },
  // {
  //   field: 'type',
  //   defaultValue: 1,
  //   component: 'Radio',
  //   label: '所属模块类型',
  //   disabled: true,
  //   placeholder: '请选择所属模块类型',
  //   radioArr: [
  //     {
  //       label: '平台管理系统',
  //       value: 1
  //     },
  //     {
  //       label: 'his管理系统',
  //       value: 2
  //     }
  //   ],
  //   rules: []
  // },

  {
    field: 'authTime',
    defaultValue: '',
    component: 'DateInterval',
    label: '授权时间',
    placeholder: '请选择授权时间',
    radioArr: [],
    rules: [
      {
        required: true,
        message: '授权时间不能为空'
      }
    ]
  },
  {
    field: 'moduleConfig',
    defaultValue: '',
    component: 'Radio',
    label: '应用配置',
    placeholder: '请选择应用配置',
    radioArr: [],
    rules: [
      {
        required: true,
        message: '请选择一个应用不能为空'
      }
    ]
  }
]

export const options = []
